import React, { FC } from 'react'
import { Icon, SemanticICONS, Step } from 'semantic-ui-react'

type Props = {
  title: string
  description: string
  icon: SemanticICONS
  active: boolean
  /*onClick: any*/
}

const PreCheckInStep: FC<Props> = ({
  title, description, icon, active/*, onClick*/
}) => {
  return (
    <Step 
      active={active} 
    >
      <Icon name={icon} />
      <Step.Content>
        <Step.Title>{title}</Step.Title>
        <Step.Description>{description}</Step.Description>
      </Step.Content>
    </Step>
  )
}

export default PreCheckInStep